/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { createContext } from "react";

/**
 * Fetch configuration extending RequestInit with additional options
 */
export type FetchConfig = RequestInit & {
  params?: Record<string, any>;
  responseType?: "json" | "text" | "blob" | "arraybuffer";
};

/**
 * Response structure that mimics axios response for compatibility
 */
export type FetchResponse<T = any> = {
  data: T;
  status: number;
  statusText: string;
  headers: Headers;
  config: FetchConfig;
  request: any;
};

export type FetchGetRequestHandler<T = any> = (
  url: string,
  config?: FetchConfig,
) => Promise<FetchResponse<T>>;

export type FetchDataRequestHandler<T = any> = (
  url: string,
  data?: any,
  config?: FetchConfig,
) => Promise<FetchResponse<T>>;

export interface APIContextState {
  baseEndpoint: string;
  $get: FetchGetRequestHandler;
  $put: FetchDataRequestHandler;
  $patch: FetchDataRequestHandler;
  $post: FetchDataRequestHandler;
  $delete: FetchDataRequestHandler;
}

export const APIContext = createContext<APIContextState | undefined>(undefined);
